import { TODO } from '@b2b/types/core/utils';
import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular, { IQService } from 'angular';
import { LoginControllerModule } from './controllers/LoginController';
import { LoginTokenControllerModule } from './controllers/LoginTokenController';

export const LoginView = angular
  .module('acme.view.login', [
    uiRouter,
    'ui.bootstrap',
    LoginControllerModule,
    LoginTokenControllerModule,
    'acme.common.directive.loader',
    'acme.common.service.api',
  ])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'login',
      url: '/login',
      abstract: true,
      views: {
        main: {
          controller: 'LoginController',
          templateUrl: 'layouts/standard.tpl.html',
        },
      },
      data: {
        pageClass: 'application-splash',
        pageTitle: 'Sign In',
      },
      resolve: {
        css: [
          '$q',
          function ($q: IQService) {
            const q = $q.defer();

            // Usage
            if ($('#splash-css').length === 0) {
              require('./../../../assets/less/splash/splash.less');
            }
            q.resolve('done');

            return q.promise;
          },
        ],

        PreFlightCheck: [
          'AuthService',
          function (AuthService: TODO) {
            return AuthService.preFlightCheck(window.location.hostname).catch((response) => response);
          },
        ],
      },
    });

    $stateProvider.state({
      name: 'login.default',
      url: '',
      views: {
        'subview-main': {
          templateUrl: 'views/login/login.tpl.html',
        },
      },
    });

    $stateProvider.state({
      name: 'login.token',
      url: '/:token',
      views: {
        'subview-main': {
          controller: 'LoginTokenController',
          templateUrl: 'views/login/loginToken.tpl.html',
        },
      },
    });
  }).name;
